type MsgReaderMimeFields = {
    contentType?: unknown;
    mimeType?: unknown;
    attachMimeTag?: unknown;
};

/**
 * MIME for a .msg attachment: prefer values from getAttachment, then @kenjiuno/msgreader list row
 * (attachMimeTag is the documented PidTagAttachMimeTag source when the blob omits type).
 */
export function msgReaderAttachmentContentType(
    fromReader: MsgReaderMimeFields | null | undefined,
    listRow: MsgReaderMimeFields | null | undefined,
): string {
    const blob = fromReader ?? {};
    const row = listRow ?? {};
    return (
        (typeof blob.contentType === 'string' && blob.contentType)
        || (typeof blob.mimeType === 'string' && blob.mimeType)
        || (typeof row.attachMimeTag === 'string' && row.attachMimeTag)
        || (typeof row.contentType === 'string' && row.contentType)
        || (typeof row.mimeType === 'string' && row.mimeType)
        || 'application/octet-stream'
    );
}
